import { TOperatorRecipient } from './types';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isValidEmail = (email: string): boolean => EMAIL_REGEX.test(email.trim());

export const collectOperatorsEmails = (operators: TOperatorRecipient[]): string[] => {
	const emails = operators
		.map((operator) => operator.email?.trim())
		.filter((email): email is string => !!email && isValidEmail(email));

	return [...new Set(emails)];
};
